class NewProductsService {
    constructor(restangular) {
        this._api = restangular.one('/Products/New');
        this.isLoading = false;
        this.cache = {};
    }

    getProducts(pageSize, pageNumber, sortType) {
        this.isLoading = true;
        const key = [pageSize, pageNumber, sortType].join('.');

        if (!(key in this.cache)) {
            this.cache[key] = this._api.get({ pageSize, pageNumber, sortType });
        }
        return this.cache[key].then((response) => {
            this.totalRecordCount = response.TotalRecordCount;
            return response;
        }).finally(() => {
            this.isLoading = false;
        });
    }
}

module.exports = NewProductsService;



// WEBPACK FOOTER //
// ./src/shop/newproducts/newproducts.service.js